/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHikingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hiking"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.6 15.88L10.1 22.52Q9.97 23 9.61 23.29Q9.25 23.57 8.75 23.57Q8.1 23.57 7.7 23.09Q7.3 22.6 7.42 21.98L10.25 7.63Q10.43 6.8 11.04 6.36Q11.65 5.92 12.35 5.92Q13 5.92 13.56 6.21Q14.13 6.5 14.47 7.08L15.47 8.68Q15.85 9.28 16.41 9.78Q16.98 10.28 17.68 10.57L17.68 10Q17.68 9.55 17.99 9.24Q18.3 8.93 18.75 8.93Q19.2 8.93 19.51 9.24Q19.82 9.55 19.82 10L19.82 22.5Q19.82 22.95 19.51 23.26Q19.2 23.57 18.75 23.57Q18.3 23.57 17.99 23.26Q17.68 22.95 17.68 22.5L17.68 13.35Q16.68 13.1 15.79 12.6Q14.9 12.1 14.2 11.43L13.75 13.65L15.4 15.2Q15.6 15.4 15.71 15.65Q15.82 15.9 15.82 16.18L15.82 22.25Q15.82 22.8 15.44 23.19Q15.05 23.57 14.5 23.57Q13.95 23.57 13.56 23.19Q13.18 22.8 13.18 22.25L13.18 17.4ZM6 13.53L4.83 13.3Q4.28 13.2 3.99 12.74Q3.7 12.28 3.8 11.72L4.55 7.8Q4.75 6.83 5.61 6.31Q6.47 5.8 7.47 6Q8 6.13 8.31 6.58Q8.63 7.03 8.5 7.58L7.53 12.47Q7.4 13 6.97 13.31Q6.55 13.63 6 13.53ZM14 5.2Q14 5.2 13.55 5.2Q13.1 5.2 12.45 4.55Q11.8 3.9 11.8 3Q11.8 2.1 12.45 1.45Q13.1 0.8 14 0.8Q14.9 0.8 15.55 1.45Q16.2 2.1 16.2 3Q16.2 3.9 15.55 4.55Q14.9 5.2 14 5.2Z" fill={color} />
    </svg>
  );
}
